import { DefaultMessages, ProgramThemeMessages, SegmentSpecificMessages } from '@sheerid/jslib';
import { RecursivePartial } from '../types/types';


type LibraryMessages = DefaultMessages & SegmentSpecificMessages & ProgramThemeMessages;

type ThisProjectMessages = {
    step: {
        error: {
            redirectButtonText: string;
        };
    };
};

export const messagesNL: RecursivePartial<LibraryMessages & ThisProjectMessages> = {
    step: {
        success: {
            verificationOnly: "SheerID zorgt alleen voor verificatie. Nu dat u bent goedgekeurd, kunt u alle vragen over de promotievoorwaarden en/of het codegebruik richten aan de klantenservice van <a href='https://www.timberland.co.uk/customer-service/contact-us.html?geoRedirect=true' target=_blank class='sid-link' >Timberland</a>.",
        },
        error: {
            redirectButtonText: 'DOORGAAN MET TIMBERLAND',
        },
    },
};
